import React, { useState, useEffect, useMemo, useRef } from "react";
import debounce from "lodash/debounce";

const SupplierSearchBox = ({ onSearch }) => {
  const [value, setValue] = useState("");
  const didMountRef = useRef(false);

  const debouncedSearch = useMemo(() => {
    return debounce((v) => {
      onSearch(v.trim());
    }, 500);
  }, [onSearch]);

  useEffect(() => {
    // جلوگیری از اجرای search اولیه با مقدار خالی هنگام mount
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    debouncedSearch(value);

    return () => {
      debouncedSearch.cancel();
    };
  }, [value, debouncedSearch]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <div className="relative mb-6">
      <input
        type="text"
        placeholder="جستجو در سفارشات (شماره یا نام کالا)..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 pl-10"
      />

      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg
          className="w-5 h-5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
    </div>
  );
};

export default SupplierSearchBox;
